import { SET_PPA_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const ppaUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_PPA_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default ppaUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/PPA/reducer.js